var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{staticClass:"home",attrs:{"fluid":""}},[(_vm.loginVisible)?_c('RegisterLogin',{on:{"signup-requested":_vm.signupRequested,"login-successful":_vm.loginSuccessful}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }